import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

/**
 * Header toggle button — single click flips between dark and light themes.
 * Uses data-testid="theme-toggle-btn" so tests can target it.
 */
export default function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggleTheme}
      className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors text-slate-400 hover:text-gold-400 hover:bg-gold-400/10 ${className}`}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </button>
  );
}
